import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { CountdownTimer } from "../CountdownTimer";
import { finalChecklist, images } from "../../data/content";
export function FinalCta() {
  return <section className="bg-navy-950 px-4 py-16 text-white sm:px-6 sm:py-24" aria-labelledby="final-title" data-id="element-161" data-mp="1nogdw68rqw0l">
      <div className="mx-auto max-w-3xl text-center" data-id="element-162" data-mp="1sm848vtrma2o">
        <p className="text-sm font-bold uppercase tracking-wide text-gold-400" data-id="element-163" data-mp="1eo1rt4nzdcw1">
          Your next challenging lower denture case deserves a clearer plan
        </p>
        <h2 id="final-title" className="mt-4 font-display text-[28px] font-black leading-tight sm:text-4xl" data-id="element-164" data-mp="14q3ulro585ra">
          Stop Relying on Scattered Information. Start Organizing Your Mandibular Denture Cases With a Structured
          Clinical Blueprint.
        </h2>
      </div>

      <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-white/[0.06] p-6 ring-1 ring-white/10 sm:p-8" data-id="element-165" data-mp="2z2247uqd73np">
        <p className="text-[17px] text-white/85" data-id="element-166" data-mp="340vj9rlav2pz">
          Imagine opening a challenging case and having a practical reference to help you:
        </p>
        <ul className="mt-5 space-y-3" data-id="element-167" data-mp="3ted33ehz4lw7">
          {finalChecklist.map(item => <li key={item} className="flex gap-3 text-base leading-snug" data-id="element-168" data-mp="b1onaejjp5zt">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold-400 text-navy-950" data-id="element-169" data-mp="6ztl77tsiokz">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-170" data-mp="3fevaeo1k4ohk" />
              </span>
              {item}
            </li>)}
        </ul>
        <p className="mt-6 text-base text-white/75" data-id="element-171" data-mp="3ogbkeuogmol9">
          You don't need another overwhelming collection of disconnected information. You need a clinical reference that
          helps you connect the important pieces.
        </p>
      </div>

      <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-172" data-mp="13osw6ulre4gv">
        <img src={images.mockup} alt="Complete Blueprint collection" className="mx-auto w-full max-w-lg drop-shadow-[0_30px_40px_rgba(0,0,0,0.5)]" data-id="element-173" data-mp="yr9hjtl5fpoe" />
        <p className="mt-8 font-display text-sm font-extrabold uppercase tracking-[0.12em] text-gold-400" data-id="element-174" data-mp="3sih9ywlto0dl">
          Get the complete collection today
        </p>
        <p className="mt-2 text-lg font-semibold text-white/90" data-id="element-175" data-mp="5drm6mx9dfwz">
          6 Premium Volumes + 5 Professional Bonuses + 30+ Clinical Decision Tools
        </p>
        <p className="mt-4 text-base text-white/60" data-id="element-176" data-mp="ab0910tcq84k">
          Total suggested value: <span className="line-through" data-id="element-177" data-mp="39u2i673okibq">$396</span>
        </p>
        <p className="mt-1 font-display text-5xl font-black text-gold-400 sm:text-6xl" data-id="element-178" data-mp="3dtbf1ku0owbi">TODAY: $27 USD</p>

        <div className="mt-9" data-id="element-179" data-mp="3isxu7zteommy">
          <CtaButton label="Yes! Give me instant access to the complete Blueprint" data-id="element-180" data-mp="3irv0zl8m283v" />
          <p className="mt-4 text-sm font-medium text-white/70" data-id="element-181" data-mp="3nko3e2glx4cs">One-time payment · Digital PDF collection · Lifetime access</p>
        </div>
        <div className="mt-8" data-id="element-182" data-mp="2q2o0whtidagi">
          <CountdownTimer tone="dark" data-id="element-183" data-mp="2v2tp1o0kketu" />
        </div>
      </div>
    </section>;
}